import { Modal, Image, Empty, Tooltip } from 'antd'
import Scrollbars from 'react-custom-scrollbars'
import styled from 'styled-components'
import { SignTitle } from '@/components'
import { useEffect, useState } from 'react'
import DOMPurify from 'dompurify'
import { useGetDetail, useGetGood } from './utils'
import EmptyImg from '@/assets/imges/Empty/Empty.png'
import { t } from '@/i18n'

export const Particulars = props => {
  const { visible, close } = props
  const [getDetail] = useGetDetail()
  const [getGood] = useGetGood()
  const [goodData, setGoodData] = useState<any>({})
  const [datas, setDatas] = useState<any>()
  const [content, setContent] = useState('')
  let [resList, setResList] = useState([])
  useEffect(() => {
    if (visible.visible) {
      getDetail({ id: visible.id })
        .then(res => {
          var b = /<a([\s]+|[\s]+[^<>]+[\s]+)href=(\"([^<>"\']*)\"|\'([^<>"\']*)\')[^<>]*>/gi
          let str = res?.data?.content?.replace(b, '<span>')
          str = str.replace(/<\/a>/gi, '</span>')
          setContent(str)
          setDatas(res?.data)
          const regs = /<a .*?href="{{.Url}}">.*?<\/a>/gim
          setResList(res?.data?.content?.match(regs))
          if (res?.data?.template_id) {
            getGood({ email_type: res?.data?.email_type, template_id: res?.data?.template_id })
              .then(response => {
                setGoodData(response.data)
              })
              .catch(err => {})
          }
        })
        .catch(err => {})
    }
  }, [visible.id])

  return (
    <Create
      title={<SignTitle show>{t('模板详情')}</SignTitle>}
      visible={visible.visible}
      onCancel={() => {
        close()
        setDatas({})
        setGoodData({})
      }}
      width={700}
      footer={[]}
      centered
    >
      {datas?.id && (
        <div style={{ height: '500px' }}>
          <Scrollbars>
            <div className="main">
              <div className="title">{t('模板名称:')}</div>
              <div className="text">{datas?.name}</div>
            </div>
            <div className="main">
              <div className="title">{t('邮件类型:')}</div>
              {datas?.email_type === 2 && <div className="accessory">{t('恶意附件')}</div>}
              {datas?.email_type === 1 && <div className="link">{t('钓鱼链接')}</div>}
            </div>
            <div className="main">
              <div className="title">{t('发件人昵称:')}</div>
              <div className="text" style={{ wordBreak: 'break-all', width: '500px' }}>
                {datas?.sender}
              </div>
            </div>
            <div className="main">
              <div className="title">{t('邮件主题:')}</div>
              <div className="text" style={{ wordBreak: 'break-all', width: '500px' }}>
                {datas?.subject}
              </div>
            </div>
            <div className="main">
              <div className="title">{t('邮件正文:')}</div>
              <div className="email-main">
                <Scrollbars>
                  <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }} />
                </Scrollbars>
              </div>
            </div>
            {datas?.link && (
              <div className="main">
                <div className="title">{t('链接名称:')}</div>
                <div className="text">{datas?.link?.join(', ') || '-'}</div>
              </div>
            )}
            {datas?.attck && (
              <div className="main">
                <div className="title">ATT&CK:</div>
                <div className="text">
                  {datas?.attck?.map((item, index) => (
                    <div key={index} style={{ marginBottom: 16 }}>
                      <a target="_blank" href={item.url} rel="noopener noreferrer">
                        {item.name}
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* {resList?.map(item => {
             const reg3 = /<a[^>]*href=['"]([^"]*)['"][^>]*>(.*?)<\/a>/gim
             if (reg3.exec(item) != null) {
               var content = RegExp.$2
             }
             return (
               <div className="main">
                 <Tooltip placement="top" title={content}>
                   <div className="title">{content}</div>
                 </Tooltip>
                 <p>{'{URL}'}</p>
               </div>
             )
            })} */}
            <div className="best">
              <p className="best-text">{t('最佳搭配')}</p>
            </div>
            {goodData?.name && (
              <div className="main">
                <div className="title">{t('模板名称:')}</div>
                <div className="text">{goodData?.name}</div>
              </div>
            )}
            {datas?.email_type === 1 && goodData?.name && (
              <div className="main">
                <div className="title">{t('钓鱼页类型:')}</div>
                {goodData?.page_type === 2 ? (
                  <div className="phishing">{t('钓鱼页')}</div>
                ) : (
                  <div className="phishing-msg">{t('钓鱼页+信息收集')}</div>
                )}
              </div>
            )}
            {datas?.email_type === 1 && goodData?.name && (
              <div className="main">
                <div className="title">{t('默认重定向页面:')}</div>
                {goodData?.page_redirect ? (
                  <a target="_blank" href={goodData?.page_redirect} rel="noopener noreferrer">
                    {goodData?.page_redirect || '-'}
                  </a>
                ) : (
                  '-'
                )}
              </div>
            )}
            {datas?.email_type === 1 && goodData?.name && (
              <div className="main">
                <div className="title" />
                <Image
                  width={200}
                  fallback={`${
                    process.env.NODE_ENV === 'dev' ? '/api' : ''
                  }/static/default/phishPage.png`}
                  src={`${process.env.NODE_ENV === 'dev' ? '/api' : ''}${goodData?.cover}`}
                />
              </div>
            )}
            {datas?.email_type === 2 && goodData?.attachment_name && (
              <div className="main">
                <div className="title">{t('附件类型:')}</div>
                {goodData?.attachment_type * 1 === 1 && <div className="accessory-exe">EXE</div>}
                {goodData?.attachment_type * 1 === 2 && <div className="accessory-doc">DOC/X</div>}
                {goodData?.attachment_type * 1 === 3 && <div className="accessory-xls">XLS/X</div>}
                {goodData?.attachment_type * 1 === 4 && <div className="accessory-ppt">PPT/X</div>}
                {goodData?.attachment_type * 1 === 5 && <div className="accessory-pdf">PDF</div>}
                {goodData?.attachment_type * 1 === 6 && <div className="accessory-rtf">RTF</div>}
              </div>
            )}
            {datas?.email_type === 2 && goodData?.attachment_name && (
              <div className="main">
                <div className="title">{t('附件：')}</div>
                <div className="text">{goodData?.attachment_name}</div>
              </div>
            )}
            {goodData?.attck && (
              <div className="main">
                <div className="title">ATT&CK:</div>
                <div className="text">
                  {goodData.attck?.map((item, index) => (
                    <div key={index} style={{ marginBottom: 16 }}>
                      <a target="_blank" href={item.url} rel="noopener noreferrer">
                        {item.name}
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {datas?.email_type === 2 && !goodData?.attachment_name && <Empty image={EmptyImg} />}
            {datas?.email_type === 1 && !goodData?.name && <Empty image={EmptyImg} />}
          </Scrollbars>
        </div>
      )}
    </Create>
  )
}

const Create = styled(Modal)`
  .main {
    display: flex;
    margin-bottom: 24px;
    .title {
      width: 105px;
      text-align: left;
      color: #86909c;
      margin-right: 12px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .best {
    font-weight: 600;
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    justify-content: space-between;
    &::after {
      content: '';
      display: inline-block;
      border-top: 1px solid #eaedf1;
      width: 0;
      flex: 1;
    }
    .best-text {
      margin: 0 10px;
      font-size: 16px;
    }
    &::before {
      content: '';
      display: inline-block;
      border-top: 1px solid #eaedf1;
      width: 24px;
    }
  }
  .email-main {
    width: 500px;
    background-color: #f7f8fa;
    border-radius: 6px;
    height: 300px;
    padding: 8px 12px;
    overflow: auto;
    * {
      color: #666;
      //position: relative !important;
    }
  }
  .accessory {
    padding: 0.02rem 0.04rem;
    background: #f5d9da;
    border-radius: 0.02rem;
    display: inline-block;
    text-align: center;
    font-size: 12px;
    color: #d0011c;
  }
  .link {
    padding: 0.02rem 0.04rem;
    background: #ebe9ff;
    border-radius: 0.02rem;
    display: inline-block;
    text-align: center;
    font-size: 12px;
    color: #645aff;
  }
  .phishing-msg {
    background: #e0f2f2;
    border-radius: 0.02rem;
    display: inline-block;
    padding: 0.02rem 0.04rem;
    text-align: center;
    font-size: 12px;
    color: #65bdc0;
  }
  .phishing {
    padding: 0.02rem 0.04rem;
    background: #d5e4ff;
    border-radius: 0.02rem;
    display: inline-block;
    text-align: center;
    font-size: 12px;
    color: #2973ff;
  }
  .accessory-exe {
    padding: 0.02rem 0.04rem;
    background: rgba(179, 89, 59, 0.2);
    border-radius: 0.02rem;
    display: inline-block;
    text-align: center;
    font-size: 12px;
    color: #b3593b;
  }
  .accessory-doc {
    padding: 0.02rem 0.04rem;
    background: rgba(0, 55, 113, 0.2);
    border-radius: 0.02rem;
    display: inline-block;
    text-align: center;
    font-size: 12px;
    color: #003771;
  }
  .accessory-xls {
    padding: 0.02rem 0.04rem;
    background: rgba(97, 164, 157, 0.2);
    border-radius: 0.02rem;
    display: inline-block;
    text-align: center;
    font-size: 12px;
    color: #61a49d;
  }
  .accessory-ppt {
    padding: 0.02rem 0.04rem;
    background: rgba(66, 106, 103, 0.2);
    border-radius: 0.02rem;
    display: inline-block;
    text-align: center;
    font-size: 12px;
    color: #426a67;
  }
  .accessory-pdf {
    padding: 0.02rem 0.04rem;
    background: #f5d9da;
    border-radius: 0.02rem;
    display: inline-block;
    text-align: center;
    font-size: 12px;
    color: #d38788;
  }
  .accessory-rtf {
    padding: 0.02rem 0.04rem;
    background: rgba(222, 118, 87, 0.2);
    border-radius: 0.02rem;
    display: inline-block;
    text-align: center;
    font-size: 12px;
    color: #de7657;
  }
`
